export enum activeContexts {
  app = 'app',
  account = 'account',
}
